<template>
    <div class="header-wrapper" :style="{'--checkout-banner-top':isApp?'0':'45px'}">
        <div class="header-bounce-patcher" :class="{showingTips}" v-if="!isApp && showCommon"></div>
        <div id="header" class="rel" :style="{ position: 'fixed' }">
            <nav class="pc-body" v-if="!isApp && showCommon">
                <div class="logo l">
                    <img :src="config.headerLogo" usemap="#header-logo" />
                    <map name="header-logo">
                        <area shape="rect"
                            coords="0,0,96,24"
                            alt="reolink"
                            @click="openOfficialUrl()"
                            target="_blank">
                        <area shape="rect"
                            coords="122,0,196,24"
                            alt="reolink"
                            @click="openCloudEvent()">
                    </map>
                </div>
                <div class="avatarAndLang r">
                    <div @click="sendGaEvent('cloud-Cloud Storage Service')" v-if="isStorageAvailableCountry || isOtherRegion">
                        <router-link
                            v-if="isStorageAvailableCountry || isOtherRegion"
                            class="link"
                            :to="{name: 'cloud-plan'}"
                        >
                            {{$t('header.cloud_plan')}}
                        </router-link>
                    </div>
                    <div @click="sendGaEvent('cloud-Cellular Data Service')">
                        <router-link
                            v-if="isDataAvailableCountry || isOtherRegion"
                            class="link"
                            :to="{name: 'sim-plan-list'}"
                        >
                            {{$t('header.sim_card')}}
                        </router-link>
                    </div>
                    <div class="dashboard">
                        <reo-nav></reo-nav>
                    </div>
                    <user-manage :is-login="isLogin"/>
                    <CountrySelector />
                </div>
            </nav>
            <nav class="mobile-body" v-if="!isApp && showCommon">
                <div class="head-menu">
                    <a href="javascript:void(0);"
                        class="menu"
                        id="show-menu"
                        @click="loginShow = !loginShow">
                        <Fade mode="out-in" :time="2">
                            <i :key="loginShow?'show':'hide'" class="menu-icon" :class="loginShow? 'icon-co_x': 'icon-icon_caidan'" />
                        </Fade>
                    </a>
                </div>
                <img v-if="!cartNav.show"
                    :src="config.logoM"
                    class="logo log-brand"
                    usemap="#header-logo-m"
                    alt="reolink">
                <div v-else class="m-cart-nav">
                    <span>{{ $t(`${cartNav.action}`) }}</span>
                    <div class="dots">
                        <div v-for="(value, index) in 3"
                            :key="index"
                            :class="[{
                                active: cartNav.step > index
                            }]"></div>
                    </div>
                    <div class="line"></div>
                    <div class="line active"
                        :style="{
                            width: cartNav.step === 1 ? '40%' : ( cartNav.step === 2 ? '60%' : '100%' )
                        }"></div>
                </div>
                <user-manage :is-login="isLogin"/>
            </nav>
            <map name="header-logo-m">
                <area shape="rect"
                    :coords="`0,0,60,30`"
                    alt="reolink"
                    :href="`${getOfficialUrl(  )}`"
                    target="_blank">
                <area shape="rect"
                    :coords="`75,0,140,30`"
                    alt="reolink"
                    href="/">
            </map>
            <div class='header-banner-box' :class="{'creatingPlan':creatingPlan && isCartPage}">
                <reo-banner
                    v-if="!totp && isShowTotpSite && !totpNoticeOff"
                    :btnText="$t('cloud.totpButton')"
                    @btnClick="open('totp')"
                    @closeClick='closeTips("totp")'
                    :text="$t('cloud.totpTips')"
                ></reo-banner>
                <reo-banner
                    v-if="isDeletingAccount && showDeletingAccountTips"
                    :btnText="$t('cloud.undoDeleteAccountBtn')"
                    @btnClick="open('undoDelete')"
                    @closeClick='closeTips'
                    :text="$t('cloud.undoDeleteAccount',{
                        time:deletingTime,
                        date:deletingDate
                    })"
                ></reo-banner>
                <template v-for='(order,i) in UnpayOrders'>
                    <reo-banner
                        v-if='UnpayOrdersTipDisplay[i] && isShowUnpay'
                        :key='order.title'
                        :btnText="$t('payment_history.pay_it_now')"
                        @btnClick="open('pay',order.id)"
                        @closeClick='closeTips("unpay",i)'
                        :text="$t('payment_history.unpayOrder','title',{
                            name:order.title
                        })"
                    ></reo-banner>
                </template>
                <E2EETip v-if="isShowE2EESite"></E2EETip>
            </div>
            <top-info></top-info>
            <login-detail-old
                :login-id="userId"
                :login-show="loginShow"
                @closeLogin="closeLogin"
            ></login-detail-old>
        </div>
    </div>

</template>

<script lang="ts">
import Vue from 'vue';
import LoginDetailOld from '@/view/reolink/Header/components/loginDetail.vue';
import TopInfo from '@/components/topInfo.vue';
import ReoBanner from '@/components/banner.vue';
import { mapGetters, mapMutations } from 'vuex';
import { config } from 'CONFIG';
import ReoNav from '@/view/reolink/Header/components/Nav.vue';
import { headerHandle } from '@/common/js/header';
import { getOrderDetailById } from '@/api/cart';
import user from '@/api/user';
import { unfoldSuc, unfoldError } from '@/common/js/notice';
import { timeResolve } from '@/common/js/date';
import reolinkGa from '@/common/js/gtagPageview';
import router from '@/router';
import E2EETip from '@/components/E2EETip.vue';
import { AxiosError } from 'axios';
import { debounce } from '@/common/js/utils';
import CountrySelector from './components/CountrySelector.vue';
import UserManage from './components/UserManage.vue';
import Fade from '@/basic/transitions/Fade.vue';

export default Vue.extend({

    props: {

        showCommon: Boolean,
        isApp: Boolean

    },

    components: {

        ReoNav,
        LoginDetailOld,
        TopInfo,
        ReoBanner,
        E2EETip,
        CountrySelector,
        UserManage,
        Fade

    },

    data () {

        let totpNoticeOff = localStorage.getItem( '2fa_notice_off' );
        return {

            langList: config.langList,
            loginShow: false,
            config,
            showTipsTop: false,
            totpNoticeOff: totpNoticeOff === 'true',
            showDeletingAccountTips: true,
            UnpayOrdersTipDisplay: []

        };

    },

    computed: {

        isLogin (): boolean {

            return Boolean( this.userId );

        },

        getCloudHost (): string {

            return window.location.hostname;

        },

        ...mapGetters( ['avatarUrl',
            'userId',
            'pageSkip',
            'cloudHost',
            'creatingPlan',
            'country',
            'isStorageAvailableCountry',
            'isDataAvailableCountry',
            'isOtherRegion'

        ] as const ),

        currenLang (): string {

            let lang = this.$store.state.lang.lang;
            return this.$t( `lang.pc.${lang}` ) as string;

        },

        cartNav (): { show: true;step: number;action: string; } | { show: false; } {

            let path = this.$route.path;
            let cartNav: { show: true;step: number;action: string; } | { show: false; };

            if ( path === '/user/update-plan/' ) {

                cartNav = {
                    show: true,
                    step: 1,
                    action: 'cart_nav.choose_plan'
                };

            } else if ( path === '/user/subscribe-plan/' ) {

                cartNav = {
                    show: true,
                    step: 1,
                    action: 'cart_nav.choose_plan'
                };

            } else if ( path === '/checkout/' || path === '/checkout/pay/' ) {

                cartNav = {
                    show: true,
                    step: 2,
                    action: 'cart_nav.confirm_details'
                };

            } else if ( path === '/checkout/payment-complete/' || path === '/user/complete/' ) {

                cartNav = {
                    show: true,
                    step: 3,
                    action: 'cart_nav.complete'
                };

            } else {

                cartNav = {
                    show: false
                };

            }
            return cartNav;

        },
        totp (): boolean {

            return !!this.$store.state.user.user.totp;

        },
        isShowE2EESite (): boolean {

            const path = this.$route.path;
            if ( path === '/user/cloud-library/' || path === '/user/my-devices/' || path === '/user/dashboard/' ) {

                return true;

            } else {

                return false;

            }

        },
        isShowTotpSite (): boolean {

            let path = this.$route.path;
            if ( path === '/user/dashboard/' ) {

                return true;

            } else {

                return false;

            }

        },
        isDeletingAccount (): boolean {

            return this.$store.state.user.user.status === 'pending';

        },
        deletingDate (): string {

            let {

                year,
                month,
                dateOfMonth

            } = timeResolve( this.$store.state.user.user.scheduledAt );
            return this.$store.state.lang.lang === 'de' ? `${dateOfMonth}.${month}.${year}` : `${year}-${month}-${dateOfMonth}`;

        },
        deletingTime (): string  {

            let {

                hour,
                minute,
                second

            } = timeResolve( this.$store.state.user.user.scheduledAt );
            return this.$store.state.lang.lang === 'de' ? `${hour}:${minute}:${second}` : `${hour}:${minute}:${second}`;

        },
        isShowUnpay (): boolean {

            let name = this.$route.name;
            if ( name === 'subscribe-cloud' || name === 'update-cloud' ) {

                return true;

            } else {

                return false;

            }

        },
        UnpayOrders (): any[] {

            let orders = this.$store.state.user.UnpayOrders;
            let series: Record<string, any> = {};
            let orderList: any[] = [];
            for ( let order of orders ) {

                if ( typeof series[order.title] === 'undefined' || series[order.title].createdAt < order.createdAt ) {

                    series[order.title] = order;

                }

            }
            Object.keys( series ).map( key => {

                orderList.push( series[key] );

            });
            return orderList.sort(( a, b ) =>

                b.createdAt - a.createdAt

            ).slice( 0, 3 ).reverse();

        },
        isCartPage (): boolean {

            return this.$route.path === '/checkout/';

        },
        showingTips(): boolean {

            return ( !this.totp && this.isShowTotpSite && !this.totpNoticeOff ) ||
            ( this.isDeletingAccount && this.showDeletingAccountTips ) ||
            ( this.UnpayOrders.length > 0 && this.isShowUnpay );

        },
        debounceCloseLogin() {

            return debounce(() => {

                this.closeLogin();

            }, 200 );

        }

    },

    methods: {

        closeLogin () {

            this.loginShow = false;

        },
        ...mapMutations({
            _setCloudHost: 'SETCLOUDHOST'
        }),

        selectLang ( lang ) {

            this.$store.commit( 'SELECT_LANG', lang );
            this.$i18n.locale = lang;
            headerHandle( this.$route );
            window.location.reload();

        },

        sendGaEvent ( event: string ) {

            reolinkGa.sendEvent( event, event );

        },

        openOfficialUrl () {

            reolinkGa.sendEvent( 'cloud-reolink-store', 'cloud-reolink-store' );
            window.location.href = `${config.reolink}/${this.country}`;

        },

        openCloudEvent () {

            reolinkGa.sendEvent( 'cloud-cloud', 'cloud-cloud' );
            window.location.href = '/';

        },
        async open ( type: string, id?: string ) {

            if ( type === 'totp' ) {

                window.location.href = config.accountCenterTotpUrl;

            } else if ( type === 'pay' ) {

                try {

                    let orderObj = await getOrderDetailById( id! );
                    router.push({

                        path: '/checkout/pay/',
                        query: {
                            order_id: orderObj.id,
                            mode: orderObj.items[0].context.action,
                            platform: config.platform
                        }

                    }).catch( console.error );

                } catch ( err ) {

                    let symbol = ( err as AxiosError ).response?.data.error.symbol;
                    if ( symbol === 'order_not_acceptable' ) {

                        window.location.reload();

                    } else if ( symbol === 'order_expired' ) {

                        unfoldError( 'order_complete.fail_reason2' );

                    }

                }

            } else {

                await user.cancelDeleteAccount();
                unfoldSuc( 'homepage.successTips' );
                reolinkGa.sendEvent( 'delete-account-canceldelete', 'account-settings' );
                this.showDeletingAccountTips = false;

            }

        },
        async closeTips ( type: string, idx?: number ) {

            if ( type === 'totp' ) {

                this.totpNoticeOff = true;
                await user.agreeContract( '2fa_notice_off', 'mfa.close_tip' );
                localStorage.setItem( '2fa_notice_off', this.totpNoticeOff ? 'true' : 'false' );

            } else if ( type === 'unpay' ) {

                this.$set( this.UnpayOrdersTipDisplay, idx!, false );

            } else {

                this.showDeletingAccountTips = false;

            }

        }

    },

    created () {

        this._setCloudHost( this.getCloudHost );

    },

    mounted () {

        window.addEventListener( 'resize', this.debounceCloseLogin );

    },

    watch: {

        pageSkip ( ) {

            this.loginShow = false;

        },
        UnpayOrders ( newVal ) {

            for ( let i in newVal ) {

                this.UnpayOrdersTipDisplay[i] = true;

            }

        }

    },

    destroyed() {

        window.removeEventListener( 'resize', this.debounceCloseLogin );

    },

});
</script>

<style lang="less" scoped>

    .header-bounce-patcher{
        height: 80px;
        @media @snapeak_mobile {
            height: 50px
        }
        &.showingTips{
            height: 144px;
            @media @snapeak_mobile{
               height: 1rem;
            }
        }
    }

    #header{
        z-index: 15;
        position: relative;
        width: 100%;
        top: 0;
    }

    #header .pc-body{
        height: 80px;
        padding: 0 .48rem;
        line-height: .38rem;
        box-sizing: border-box;
        position: relative;
        background-color: #fff;
        box-shadow : 0 6px 22px rgba(0, 0, 0, 0.05);
        -webkit-box-shadow: 0 6px 22px rgba(0, 0, 0, 0.05);
        -moz-box-shadow: 0 6px 22px rgba(0, 0, 0, 0.05);
        -o-box-shadow: 0 6px 22px rgba(0, 0, 0, 0.05);
        -ms-box-shadow: 0 6px 22px rgba(0, 0, 0, 0.05);
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    #header .pc-body .nav-item:hover{
        cursor: pointer;
    }

    #header .pc-body a{
        font-weight: 500;
    }

    #header .pc-body .logo{
        display: flex;
        align-items: center;
        cursor: pointer;
        height: 100%;
    }

    #header .mobile-body{
        padding: 0 20px;
        background-color: #fff;
        box-shadow : 0px 4px 10px 0px rgba(0, 0, 0, 0.05);;
        -webkit-box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);;
        -moz-box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);;
        -o-box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);;
        -ms-box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);;
        justify-content: space-between;
        align-items: center;

    }

    #header .mobile-body .head-menu .menu-icon{
        font-size: 24px;
        color: #333;
    }

    #header .mobile-body .head-menu .menu {
        display: block;
    }

    #header .mobile-body .head-brand img{
        height: .32rem;
        width: auto;
        position: relative;
        top: -.08rem;
    }

    .avatarAndLang .nav-item{
        line-height: .88rem;
        position: relative;
    }

    .avatarAndLang .nav-item.lang{
        font-size: 0.16rem;
        .current-lang{
            color: @font_primary;
            &:hover{
                color: @font_primary;
            }
        }
    }

    #header .mobile-body .head-brand{
        margin-left: 1.54rem;
    }

    #header .mobile-body{
        display: none;
    }

    .cloud-fillter{
        position: static;
        top: 0.88rem;
        width: 100%;
        z-index: 4;
    }

    .cloud-fillter.haveBanner{
        top: 1.49rem;
    }

    .app-platform .cloud-fillter {
        &, &.haveBanner {
            top: 0rem;
        }
    }

    @media screen and ( max-width: 1199px ) {
        .cloud-fillter{
            top: 1rem;
        }
        .app-platform .cloud-fillter {
            top: 0rem;
        }
        #header .pc-body{
            display: none;
        }
        #header .mobile-body{
            display: flex;
            height: 50px;
            box-sizing: border-box;
            position: relative;
        }
        #header .mobile-body .head-menu{
            float: left;
        }
        .log-brand{
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            -webkit-transform: translate(-50%,-50%);
            width: 141px;
        }
        .log-brand img{
            width: 100%;
        }
    }
    .m-cart-nav{
        &>span{
            position: absolute;
            display: block;
            text-align: center;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 0.36rem;
        }
        .line{
            position: absolute;
            width: 100%;
            border-top: 1px solid #B1B1B1;
            left: 0;
            bottom: 0;
            &.active{
                border-color: @theme;
            }
        }
        .dots{
            position: absolute;
            width: 100%;
            left: 0;
            bottom: -0.05rem;
            text-align: center;
            height: 0.1rem;
            font-size: 0;
            div{
                display: inline-block;
                width: 0.1rem;
                height: 0.1rem;
                border-radius: 100%;
                background-color: #B1B1B1;
                &.active{
                    background-color: @theme;
                }
            }
            div+div{
                margin-left: 1.2rem;
            }
        }

    }
    .header-banner-box{
        @media @mobile {
            position: fixed;
            bottom: 0;
            width: 100%;
            &.creatingPlan{
                bottom:1.5rem;
            }
        }
    }
    .r{
        display: flex;
        gap: 50px;
        align-items: center;
        .link{
            font-size: 16px;
            font-weight: 500;
            color: @font_primary;
            &:hover{
                color: @theme;
            }
        }
    }
</style>

<style>
.dialogActivated #header{
    width: calc(100% - var(--scrollbar-width));
}
</style>
